import React from "react";
import { useErrorToast } from "features/patientDashboard/hooks/useErrorToast";
import { Subscription } from "types/Subscription";
import { getSubscriptionStatusRequest } from "api/getSubscriptionRequest";

export const useSubscriptions = (
  patientId?: string
): {
  subscriptions: Subscription[] | undefined;
} => {
  const [subscriptions, setSubscriptions] = React.useState<
    undefined | Subscription[]
  >(undefined);
  const { showErrorToast } = useErrorToast();

  React.useEffect(() => {
    if (!patientId) {
      return;
    }

    const fetchSubscriptions = async () => {
      try {
        const data = await getSubscriptionStatusRequest(patientId);
        setSubscriptions(data);
      } catch (e) {
        showErrorToast();
      }
    };

    fetchSubscriptions();
  }, [showErrorToast, setSubscriptions, patientId]);

  return { subscriptions };
};
